import { useContext } from "react";

import { useHistory } from "react-router";

import Swal from "sweetalert2";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  findByCEP,
  findByCNPJ,
  findByCPF,
} from "../../../../repository/services/BigDataService";

import { findUsuarios } from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";

import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import MaskService from "../../../../utils/mask/maskService";
import StringService from "../../../../utils/stringService";

import { ClienteContext } from "../contexts/ClienteContext";
import {
  createCliente,
  deleteCliente,
  findCliente,
  findClienteByCpfCnpj,
  updateCliente,
} from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { GlobalVariables } from "../../../../GlobalVariables";
import { useCallback } from "react";
import { findTransportadora } from "../../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";
import { formatDate } from "../../../../utils/formatDate";

export default function useClienteController() {
  const {
    //Dados Gerais
    generalWebsite,
    generalCustomerId,
    setGeneralTypeSubscription,
    generalCpfCnpj,
    setGeneralCpfCnpj,
    generalName,
    setGeneralName,
    generalFantasy,
    setGeneralFantasy,
    generalCep,
    setGeneralCep,
    setGeneralAddress,
    generalNewAddress,
    setGeneralNewAddress,
    generalNumber,
    setGeneralNumber,
    generalComplement,
    setGeneralComplement,
    generalDistrict,
    setGeneralDistrict,
    generalUf,
    setGeneralUf,
    generalCounty,
    setGeneralCounty,
    generalNation,
    setGeneralNation,
    generalTelephone1,
    setGeneralTelephone1,
    generalTelephone2,
    setGeneralTelephone2,
    generalTelephone3,
    setGeneralTelephone3,
    generalEmail,
    setGeneralEmail,
    generalRg,
    setGeneralRg,
    generalIe,
    setGeneralIe,
    generalSimpleNational,
    setGeneralSimpleNational,
    generalFinalCustomer,
    setGeneralFinalCustomer,
    generalIm,
    setGeneralIm,
    generalCcm,
    setGeneralCcm,
    generalIsuf,
    setGeneralIsuf,
    generalCheckBudget,
    setGeneralCheckBudget,
    generalCheckNfe,
    setGeneralCheckNfe,
    generalCheckFinancial,
    setGeneralCheckFinancial,
    generalActive,
    setGeneralActive,
    generalMatriz,
    setGeneralMatriz,
    generalSendEmail,
    setGeneralSendEmail,
    generalDateInitial,
    setGeneralDateInitial,
    generalIeIndication,
    setGeneralIeIndication,
    setGeneralCustomerId,
    setGeneralWebsite,
    generalSendHub,
    setGeneralSendHub,
    ruralProducer,
    setRuralProducer,
    setValidCpfCnpj,

    //Endereços
    billingCep,
    setBillingCep,
    setBillingAddress,
    billingNewAddress,
    setBillingNewAddress,
    billingNumber,
    setBillingNumber,
    billingComplement,
    setBillingComplement,
    billingCounty,
    setBillingCounty,
    billingUf,
    setBillingUf,
    billingDistrict,
    setBillingDistrict,
    deliveryAddress,
    setDeliveryAddress,
    setLoadingTable,

    //Estabelecimentos Rurais
    ruralEstablishment,
    setRuralEstablishment,

    //Contatos
    contacts,
    setContacts,

    //Autorizados
    authorized,
    setAuthorized,

    //Relacionados
    mainCustomer,
    setMainCustomer,
    dependentCustomer,
    setDependentCustomer,
    setRelationship,

    //Info. Comerciais
    salesman,
    setSalesman,
    commercialPartner,
    setCommercialPartner,
    defaultPayment,
    setDefaultPayment,
    typePayment,
    setTypePayment,
    tableShipping,
    setTableShipping,
    shippingDiscount,
    setShippingDiscount,
    defaultDiscount,
    setDefaultDiscount,
    shippingCompany,
    setShippingCompany,
    irWithheld,
    setIrWithheld,
    issWithheld,
    setIssWithheld,
    commercialRegionSelect,
    setCommercialRegionSelect,
    invertDiscount,
    setInvertDiscount,

    //Info. Financeiras
    hasRestriction,
    setHasRestriction,
    hasLimit,
    setHasLimit,
    lastSearchSerasa1,
    setLastSearchSerasa1,
    lastSearchSerasa2,
    setLastSearchSerasa2,
    lastSearchSerasa3,
    setLastSearchSerasa3,
    limitValue,
    setLimitValue,
    generateCommission,
    setGenerateCommission,
    riskClass,
    setRiskClass,
    financialObservation,
    setFinancialObservation,
    billingAlert,
    setBillingAlert,
    bankInformations,
    setBankInformations,
    minimumOrder,
    setMinimumOrder,

    //Outras Informações
    otherShippingCompany,
    setOtherShippingCompany,
    otherOwnHome,
    setOtherOwnHome,
    otherBirthDate,
    setOtherBirthDate,
    otherFathersName,
    setOtherFathersName,
    otherRgFather,
    setOtherRgFather,
    otherCpfFather,
    setOtherCpfFather,
    otherMothersName,
    setOtherMothersName,
    otherRgMother,
    setOtherRgMother,
    otherCpfMother,
    setOtherCpfMother,
    otherAdditionalData,
    setOtherAdditionalData,
    otherCompanyName,
    setOtherCompanyName,
    otherIssueDate,
    setOtherIssueDate,
    otherRemuneration,
    setOtherRemuneration,
    otherRole,
    setOtherRole,
    otherTelephone,
    setOtherTelephone,
    otherCounty,
    setOtherCounty,
    otherAddress,
    setOtherAddress,
    otherTypeResidence,
    setOtherTypeResidence,
    otherTimeResidence,
    setOtherTimeResidence,
    otherFamilyIncome,
    setOtherFamilyIncome,
    otherPersonalReference,
    setOtherPersonalReference,
    otherCommercialReference,
    setOtherCommercialReference,
    otherNoteNfe,
    setOtherNoteNfe,
    otherPartners,
    setOtherPartners,

    //Dados do Cônjuge
    spousesName,
    setSpousesName,
    spousesBirthDate,
    setSpousesBirthDate,
    spousesTelephone,
    setSpousesTelephone,
    spousesRg,
    setSpousesRg,
    spousesCpf,
    setSpousesCpf,
    spousesCompany,
    setSpousesCompany,
    spousesAdmissionDate,
    setspousesAdmissionDate,
    spousesRole,
    setSpousesRole,
    spousesRemuneration,
    setSpousesRemuneration,
    spousesCounty,
    setSpousesCounty,
    spousesAddress,
    setSpousesAddress,

    //Tabela Preco Cliente
    customerPriceTable,

    setExpanded,
    listUf,
    listCounty,
    listNation,
    setLoading,
    setErrors,
    loadingInputs,
    showPlugAdd,
  } = useContext(ClienteContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { push, go } = useHistory();

  const clearAccordionCpf = () => {
    setOtherBirthDate("");
    setOtherFathersName("");
    setOtherRgFather("");
    setOtherCpfFather("");
    setOtherMothersName("");
    setOtherRgMother("");
    setOtherCpfMother("");
    setOtherAdditionalData("");
    setOtherCompanyName("");
    setOtherIssueDate("");
    setOtherRemuneration("0,00");
    setOtherRole("");
    setOtherTelephone("");
    setOtherCounty(null);
    setOtherAddress("");
    setOtherTypeResidence(null);
    setOtherTimeResidence("");
    setOtherFamilyIncome("0,00");
    setOtherPersonalReference("");
    setOtherCommercialReference("");
    setOtherNoteNfe("");

    //Dados do Cônjuge
    setSpousesName("");
    setSpousesBirthDate("");
    setSpousesTelephone("");
    setSpousesRg("");
    setSpousesCpf("");
    setSpousesCompany("");
    setspousesAdmissionDate("");
    setSpousesRole("");
    setSpousesRemuneration("0,00");
    setSpousesCounty(null);
    setSpousesAddress("");
  };

  const clearAccordionCnpj = () => {
    setOtherBirthDate("");
    setOtherAdditionalData("");
    setOtherCommercialReference("");
    setOtherNoteNfe("");
    setOtherPartners([]);
  };

  const optionsSetters = {
    general: {
      setCpfCnpj: setGeneralCpfCnpj,
      setName: (value) => setGeneralName(value.substring(0, 50)),
      setFantasy: (value) => setGeneralFantasy((value || "").substring(0, 50)),
      setCep: setGeneralCep,
      //setAddress: (value) => setGeneralAddress(value.substring(0, 120)),
      setNewAddress: (value) =>
        setGeneralNewAddress((value || "").substring(0, 60)),
      setNumber: setGeneralNumber,
      setComplement: (value) => setGeneralComplement(value.substring(0, 60)),
      setDistrict: (value) => setGeneralDistrict(value.substring(0, 60)),
      setUf: setGeneralUf,
      setCounty: setGeneralCounty,
      setTelephone: setGeneralTelephone1,
      setEmail: setGeneralEmail,
    },
    billing: {
      setCep: setBillingCep,

      //setAddress: (value) => setBillingAddress((value || "").substring(0, 120)),
      setNewAddress: (value) =>
        setBillingNewAddress((value || "").substring(0, 60)),
      setNumber: setBillingNumber,
      setComplement: (value) =>
        setBillingComplement((value || "").substring(0, 60)),
      setCounty: setBillingCounty,
      setUf: setBillingUf,
      setDistrict: (value) =>
        setBillingDistrict((value || "").substring(0, 60)),
    },
  };

  const handleFindByCepHub = async (
    cep,
    context,
    settersProp,
    byOtherFunction = false
  ) => {
    try {
      setLoading(true);
      const setters = settersProp || optionsSetters[context];

      const response = await findByCEP(cep);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        if (responseData.data.stateCode) {
          setters.setUf(
            listUf.find((opt) => opt.estado === responseData.data.stateCode) ||
              null
          );
        }

        if (responseData.data.street) {
          typeof setters.setNewAddress === "function"
            ? setters.setNewAddress(responseData.data.street)
            : setters.setAddress(responseData.data.street);
        }

        if (responseData.data.neighborhood) {
          setters.setDistrict(responseData.data.neighborhood);
        }

        if (responseData.data.additionalInfo) {
          setters.setComplement(responseData.data.additionalInfo);
        }

        if (responseData.data.ibgeCode) {
          setters.setCounty(
            listCounty.find(
              (opt) => opt.codigo === responseData.data.ibgeCode
            ) || null
          );
        }

        return;
      }
      if (
        byOtherFunction ||
        generalUf?.codibge === GlobalVariables.state.external
      )
        return;

      notify("CEP não encontrado.");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteClienteHandler = async (id, setLoading = () => {}) => {
    try {
      const callback = await deleteCliente(id, queryParams.empresa_cnpj);

      if (callback && callback.success) {
        notify("Cliente excluído com sucesso!", true, "success");
      } else {
        notify("Ocorreu um erro ao excluir o cliente.");
      }

      return callback;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleFindByCnpjHub = async (cnpj, context) => {
    try {
      setLoading(true);

      const setters = optionsSetters[context];

      const response = await findByCNPJ(cnpj);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        setters.setName(
          (responseData.data.corporate_name || "").substring(0, 50)
        );
        setters.setFantasy(
          (
            responseData.data.commercial_name ||
            responseData.data.corporate_name ||
            ""
          ).substring(0, 20)
        );

        if (responseData.data.phones.length > 0) {
          let validPhone = /\b(0[0-9]{2})\b/.test(
            responseData.data.phones[0]?.number
          )
            ? responseData.data.phones[0].number.replace("0", "")
            : responseData.data.phones[0].number;

          setters.setTelephone(
            MaskService.toMask("cel-phone", validPhone || "")
          );
        }
        setters.setEmail(responseData.data.emails[0]?.email || "");

        if (responseData.data.addresses[0].postalCode) {
          handleChangeCep(
            { target: { value: responseData.data.addresses[0].postalCode } },
            "general",
            null,
            true
          );
          setters.setNewAddress(responseData.data.addresses[0].street);
          setters.setNumber(responseData.data.addresses[0].number);
          setters.setDistrict(responseData.data.addresses[0].bairro);
        }

        setters.setUf(
          listUf.find(
            (opt) => opt.estado === responseData.data.addresses[0].stateCode
          ) || null
        );
        const endereco = await findByCEP(
          responseData.data.addresses[0].postalCode
        );
        const enderecoData = endereco?.data;

        if (endereco.success && enderecoData.statusCode === 200) {
          setters.setCounty(
            listCounty.find(
              (opt) => opt.codigo === enderecoData.data.ibgeCode
            ) || null
          );

          if (enderecoData.data?.additionalInfo)
            setters.setComplement(enderecoData.data.additionalInfo);

          if (enderecoData.data?.neighborhood)
            setters.setDistrict(enderecoData.data.neighborhood);
        } else {
          setters.setCounty(null);
        }

        return notify("Preenchimento automático realizado.", true, "success");
      }

      notify(
        "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFindByCpfHub = async (cpf, context) => {
    try {
      setLoading(true);

      const setters = optionsSetters[context];

      const response = await findByCPF(cpf);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        setters.setName((responseData.data.name || "").substring(0, 50));
        return notify("Preenchimento automático realizado.", true, "success");
      } else if (responseData.statusCode === 406) {
        return notify(
          "Preenchimento automático não disponível para esse CPF.",
          true,
          "warning"
        );
      }
      notify(
        "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFindCustomerExists = async (cpfCnpj, context) => {
    try {
      setLoading(true);

      const setters = optionsSetters[context];

      const customerExists = await findCliente({
        empresa_cnpj: queryParams.empresa_cnpj,
        where: { "%cpfcnpj%": cpfCnpj.replace(/[^0-9]+/g, "") },
      });

      if (
        customerExists.data?.length &&
        (customerExists.data || []).find(
          (current) => current.id !== generalCustomerId
        )
      ) {
        setters.setCpfCnpj("");
        notify("Já existe um cliente com este Nº de inscrição.");
        return true;
      }

      return false;
    } catch (error) {
      notify("Não foi possível verificar se este cliente já existe.");
      console.error(error);
      return true;
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCpfCnpj = async (e, context) => {
    const inputValue = generalCpfCnpj.replaceAll(/[^0-9]/g, "");

    let mask,
      typeMask = inputValue;

    const setters = optionsSetters[context];

    if (inputValue.length === 14) {
      mask = "cnpj";
      typeMask = MaskService.toMask(mask, inputValue);
    } else if (inputValue.length === 11) {
      mask = "cpf";
      typeMask = MaskService.toMask(mask, inputValue);
    }

    const newNumInscricao = typeMask;
    setters.setCpfCnpj(newNumInscricao);

    if (mask === "cnpj" && newNumInscricao.length === 18) {
      setGeneralTypeSubscription({
        description: "CNPJ",
        value: "cnpj",
      });
      if (await handleFindCustomerExists(newNumInscricao, context)) return;

      await handleFindByCnpjHub(newNumInscricao, context);
    } else if (mask === "cpf" && newNumInscricao.length === 14) {
      if (await handleFindCustomerExists(newNumInscricao, context)) return;
      setGeneralTypeSubscription({
        description: "CPF",
        value: "cpf",
      });
      await handleFindByCpfHub(newNumInscricao, context);
    }
  };

  const handleChangeCep = (
    e,
    context,
    settersProp,
    byOtherFunction = false
  ) => {
    const setters = settersProp || optionsSetters[context];

    setters.setCep(MaskService.toMask("cep", e.target.value));

    if (e.target.value.length === 10) {
      document.activeElement.blur();
      handleFindByCepHub(e.target.value, context, settersProp, byOtherFunction);
    }
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const handleSearchSelectShippingCompany = (selectedShippingCompany) => {
    if (selectedShippingCompany) {
      setOtherShippingCompany(selectedShippingCompany);
    }
  };

  const handleDialogShippingCompany = (
    setOpenTransp = () => {},
    selectedShippingCompany
  ) => {
    setOtherShippingCompany(selectedShippingCompany[0]);
    setOpenTransp(false);
  };

  const handleFindShippingCompany = useCallback(
    async (id) => {
      try {
        const shippingCompany = await findTransportadora(
          queryParams.empresa_cnpj,
          id
        );

        if (shippingCompany.data) {
          setOtherShippingCompany(shippingCompany.data);
        }
      } catch (error) {
        notify("Não foi possível carregar as informações da transportadora.");
        console.error(error);
      }
    },
    [queryParams.empresa_cnpj, setOtherShippingCompany]
  );

  const handleSubmit = async (again) => {
    try {
      const hasLoading = Object.keys(loadingInputs).find(
        (key) => loadingInputs[key]
      );

      if (hasLoading)
        return notify("Aguarde todos os campos serem carregados.");

      setLoading(true);

      //Dados Gerais
      const resultValidation = validNotNull([
        { key: "generalCpfCnpj", value: generalCpfCnpj },
        { key: "generalName", value: generalName },
        { key: "generalFantasy", value: generalFantasy },
        { key: "generalCep", value: generalCep },
        { key: "generalNewAddress", value: generalNewAddress },
        { key: "generalNumber", value: generalNumber },
        { key: "generalDistrict", value: generalDistrict },
        { key: "generalUf", value: generalUf },
        { key: "generalCounty", value: generalCounty },
        { key: "generalNation", value: generalNation },
      ]);

      resultValidation.errorsValidation.accordions = resultValidation.error
        ? ["general"]
        : [];

      let typeSubscription = null,
        cpfCnpjReplaced = generalCpfCnpj.replace(/[^0-9]+/g, "");

      if (cpfCnpjReplaced.length === 11)
        typeSubscription = { value: "cpf", description: "CPF" };
      else if (cpfCnpjReplaced.length === 14)
        typeSubscription = { value: "cnpj", description: "CNPJ" };
      if (
        generalCep &&
        !MaskService.isValid("cep", generalCep) &&
        generalUf?.codibge !== GlobalVariables.state.external
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalCep = "CEP inválido";
      } else {
        resultValidation.errorsValidation.generalCep = false;
      }

      if (
        generalTelephone1 &&
        !MaskService.isValid("cel-phone", generalTelephone1)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone1 =
          "Telefone inválido";
      }

      if (
        generalTelephone2 &&
        !MaskService.isValid("cel-phone", generalTelephone2)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone2 =
          "Telefone inválido";
      }

      if (
        generalTelephone3 &&
        !MaskService.isValid("cel-phone", generalTelephone3)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone3 =
          "Telefone inválido";
      }

      //Endereços
      if (
        billingCep &&
        !MaskService.isValid("cep", billingCep) &&
        billingUf?.codibge === GlobalVariables.state.external
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.billingCep = "CEP inválido";
        resultValidation.errorsValidation.accordions.push("address");
      }

      //Outras informações
      if (otherCpfFather && !MaskService.isValid("cpf", otherCpfFather)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.otherCpfFather = "CPF inválido";
        resultValidation.errorsValidation.accordions.push("othersInfo");
      }

      if (otherCpfMother && !MaskService.isValid("cpf", otherCpfMother)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.otherCpfMother = "CPF inválido";
        resultValidation.errorsValidation.accordions.push("othersInfo");
      }

      if (otherTelephone && !MaskService.isValid("cel-phone", otherTelephone)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.otherTelephone = "Telefone inválido";
        resultValidation.errorsValidation.accordions.push("othersInfo");
      }

      //Dados do Cônjuge
      if (
        spousesTelephone &&
        !MaskService.isValid("cel-phone", spousesTelephone)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.spousesTelephone =
          "Telefone inválido";
        resultValidation.errorsValidation.accordions.push("othersInfo");
      }

      if (spousesCpf && !MaskService.isValid("cpf", spousesCpf)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.spousesCpf = "CPF inválido";
        resultValidation.errorsValidation.accordions.push("othersInfo");
      }

      if (!generalCustomerId) {
        const resultSubscription = await findClienteByCpfCnpj(
          queryParams.empresa_cnpj,
          cpfCnpjReplaced
        );

        if (resultSubscription?.data?.length) {
          resultSubscription?.data.forEach((result) => {
            if (
              result?.cpfcnpj?.replace(/[^0-9]+/g, "") ===
              generalCpfCnpj?.replace(/[^0-9]+/g, "")
            ) {
              resultValidation.error = true;
              resultValidation.errorsValidation.generalCpfCnpj = `${
                typeSubscription
                  ? typeSubscription.description.toUpperCase()
                  : "Código"
              } já utilizado em outro cliente.`;
            }
          });
        }
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return notify("Verifique se os campos estão preenchidos corretamente.");
      }

      if (ruralProducer && !ruralEstablishment?.length) {
        setLoading(false);
        return notify(
          "Estabelecimento Rural é obrigatório para Produtor Rural.",
          true,
          "warning"
        );
      }

      const userLogin = await findUsuarios(
        queryParams.empresa_cnpj,
        queryParams.usuario_id
      );

      if (!userLogin.success || !userLogin.data) {
        return notify(
          "Ocorreu um erro. Tente novamente com um usuário diferente."
        );
      }

      const body = {
        //Dados Gerais
        idempresa: parseInt(queryParams.empresa_id) || 6,
        quemcadastrou: userLogin.data.login || "",
        idcategoria:
          generalCpfCnpj.replace(/[^0-9]+/g, "").length === 14 ? 2 : 1,
        ativo: generalActive ? "S" : "N",
        cpfcnpj: generalCpfCnpj.replace(/[^0-9]+/g, ""),
        apelido: generalFantasy,
        razao: generalName,
        cep: generalCep.replace(/[^0-9]+/g, ""),
        endereco: `${generalNewAddress.trim()}${
          generalNumber ? ` , ${generalNumber.trim()}` : ""
        }`,
        complemento: generalComplement,
        bairro: generalDistrict,
        id_estado: generalUf ? generalUf.id : null,
        cidade: generalCounty ? generalCounty.municipio : null,
        municipio_codigo: generalCounty ? generalCounty.codigo : null,
        idpais: generalNation ? generalNation.codigo : null,
        ddd1: generalTelephone1.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone1: generalTelephone1.replace(/[^0-9]+/g, "").substring(2),
        ddd2: generalTelephone2.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone2: generalTelephone2.replace(/[^0-9]+/g, "").substring(2),
        ddd3: generalTelephone3.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone3: generalTelephone3.replace(/[^0-9]+/g, "").substring(2),
        email: generalEmail,
        ie: generalIe,
        rg: generalRg,
        simples_nacional: generalSimpleNational ? "S" : "N",
        consumidorfinal: generalFinalCustomer ? "1" : "0",
        inscricao_municipal: generalIm,
        ccm: generalCcm,
        isuf: generalIsuf,
        indiedest: generalIeIndication ? generalIeIndication.codigo : null,
        enviarmailcontasvencer: generalSendEmail ? "S" : "N",
        email_utilizarorcamentovenda: generalCheckBudget ? "S" : "N",
        email_utilizarnfe: generalCheckNfe ? "S" : "N",
        email_utilizarfinanceiro: generalCheckFinancial ? "S" : "N",
        idclientematriz: generalMatriz ? generalMatriz.id : null,
        cliente_desde: generalDateInitial,
        homepage: generalWebsite,
        clientdevi: "N",
        usar_certificado_cliente: "0",
        produtor_rural: ruralProducer ? 1 : 0,

        //Endereços
        cep_cobranca: billingCep.replace(/[^0-9]+/g, ""),
        endereco_cobranca: `${billingNewAddress}, ${billingNumber}`,
        complemento_cobranca: billingComplement,
        cidade_cobranca: billingCounty ? billingCounty.municipio : null,
        municipio_codigo_cobranca: billingCounty ? billingCounty.codigo : null,
        id_estado_cobranca: billingUf ? billingUf.id : null,
        bairro_cobranca: billingDistrict,
        clientesentregas: deliveryAddress,

        //Estabelecimentos Rurais
        estabelecimentosRurais: ruralEstablishment,

        //Contatos
        clientescontatos: contacts,

        //Autorizados
        clientesautorizados: authorized,

        //Relacionados
        titulares: mainCustomer.map((customer) => ({
          ...customer,
          tipo: customer.tipo.toLowerCase(),
        })),
        dependentes: dependentCustomer.map((customer) => ({
          ...customer,
          tipo: customer.tipo.toLowerCase(),
        })),

        //Info. Comerciais
        idvendedor: salesman ? salesman.id : null,
        idparceirocomercial: commercialPartner ? commercialPartner.id : null,
        id_tipopagamento: defaultPayment ? defaultPayment.id : null,
        idformapagto: typePayment ? typePayment.id : null,
        idtabelafrete: tableShipping ? tableShipping.id : null,
        descontofrete: MaskService.removeMaskDecimal(shippingDiscount) || "",
        descporc: MaskService.removeMaskDecimal(defaultDiscount) || "",
        idempresafrete: shippingCompany ? shippingCompany.id : null,
        nfse_ir_porc_retido: MaskService.removeMaskDecimal(irWithheld) || "",
        nfse_iss_porc_retido: MaskService.removeMaskDecimal(issWithheld) || "",
        regiaocomercial: commercialRegionSelect
          ? commercialRegionSelect.id.toString()
          : "",
        diporc: MaskService.removeMaskDecimal(invertDiscount) || "",

        //Info. Financeiras
        alerta_faturamento: billingAlert,
        restricao: hasRestriction ? "SIM" : "NAO",
        possui_limite: hasLimit ? "SIM" : "NAO",
        geracomissao: generateCommission ? "S" : "N",
        idclasserisco: riskClass ? riskClass.id : null,
        valor_limite: hasLimit
          ? MaskService.removeMaskDecimal(limitValue)
          : null,
        pedido_minimo: minimumOrder
          ? MaskService.removeMaskDecimal(minimumOrder)
          : null,
        observacao: financialObservation,
        consultaserasa1: lastSearchSerasa1,
        consultaserasa2: lastSearchSerasa2,
        consultaserasa3: lastSearchSerasa3,
        contasbancarias: bankInformations,

        //Outras Informações
        idtransportadora: otherShippingCompany ? otherShippingCompany.id : null,
        casa_propria: otherOwnHome ? otherOwnHome.value : null,
        datanascimento: otherBirthDate,
        nome_pai: otherFathersName,
        rg_pai: otherRgFather.replace(/[^0-9]+/g, ""),
        cpf_pai: otherCpfFather.replace(/[^0-9]+/g, ""),
        nome_mae: otherMothersName,
        rg_mae: otherRgMother.replace(/[^0-9]+/g, ""),
        cpf_mae: otherCpfMother.replace(/[^0-9]+/g, ""),
        dadosadicionais: otherAdditionalData,
        trabalho_empresa: otherCompanyName,
        trabalho_data_admissao: otherIssueDate,
        trabalho_salario: otherRemuneration
          .replace(/\./g, "")
          .replace(",", "."),
        trabalho_funcao: otherRole,
        trabalho_telefone: otherTelephone.replace(/[^0-9]+/g, ""),
        trabalho_municipio_codigo: otherCounty ? otherCounty.codigo : null,
        trabalho_endereco: otherAddress,
        estabelecimento_tipo: otherTypeResidence
          ? otherTypeResidence.value
          : null,
        estabelecimento_descricao: otherTypeResidence
          ? otherTypeResidence.label
          : null,
        estabelecimento_tempo: otherTimeResidence,
        renda_familiar: MaskService.removeMaskDecimal(otherFamilyIncome) || "",
        referencia_pessoal: otherPersonalReference,
        referencia_comercial: otherCommercialReference,
        obsnfe: otherNoteNfe,
        clientessocios: otherPartners,

        //Dados do Cônjuge
        conjuge_nome: spousesName,
        conjuge_data_nasc: spousesBirthDate,
        conjuge_telefone: spousesTelephone.replace(/[^0-9]+/g, ""),
        conjuge_rg: spousesRg.replace(/[^0-9]+/g, ""),
        conjuge_cpf: spousesCpf.replace(/[^0-9]+/g, ""),
        trab_conjuge_empresa: spousesCompany,
        trab_conjuge_data_admissao: spousesAdmissionDate,
        trab_conjuge_funcao: spousesRole,
        trab_conjuge_salario:
          MaskService.removeMaskDecimal(spousesRemuneration) || "",
        trab_conjuge_municipio_codigo: spousesCounty
          ? spousesCounty.codigo
          : null,
        trab_conjuge_endereco: spousesAddress,
        send_to_qyon_hub: showPlugAdd && generalSendHub,

        //Tabela Preco Cliente
        tabelapreco: customerPriceTable,
      };

      let resultSubmit = null;

      if (generalCustomerId) {
        resultSubmit = await updateCliente(
          generalCustomerId,
          queryParams.empresa_cnpj,
          {
            cliente: body,
          }
        );
      } else {
        resultSubmit = await createCliente(queryParams.empresa_cnpj, {
          cliente: body,
        });
      }

      if (resultSubmit && resultSubmit.success) {
        setGeneralCustomerId(null);
        if (again) {
          push("cadastro");
          go(0);
          return notify("Cliente salvo com sucesso.", true, "success");
        } else {
          push("/prouser/cliente/listagem");
          return notify("Cliente salvo com sucesso.", true, "success");
        }
      }

      let errorMessage =
        resultSubmit?.message || "Não foi possível salvar os dados do cliente.";

      return notify(errorMessage);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubmit = () => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja cancelar?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setGeneralCustomerId(null);
        push("/prouser/cliente/listagem");
      }
    });
  };

  const handleBackSubmit = () => {
    setGeneralCustomerId(null);
    push("/prouser/cliente/listagem");
  };

  const handleRemoveItemTable = useCallback(
    (setRows, setDataTable, list, index) => {
      Swal.fire({
        icon: "question",
        text: "Tem certeza que deseja remover este registro?",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const copy = [...list];
          copy.splice(index, 1);
          setRows(copy);
          setDataTable(copy);
          notify("Cadastro excluído com sucesso!", true, "success");
        }
      });
    },
    []
  );

  const handleAddRelationship = useCallback(
    (item, position) => {
      switch (position) {
        case "Titular":
          setMainCustomer((mainCustomerCopy) => [
            ...mainCustomerCopy,
            {
              cliente_titular_id: item.id,
              tipo: StringService.capitalize(item.pivot.tipo),
            },
          ]);
          break;

        case "Dependente":
          setDependentCustomer((dependentCustomerCopy) => [
            ...dependentCustomerCopy,
            {
              cliente_dependente_id: item.id,
              tipo: StringService.capitalize(item.pivot.tipo),
            },
          ]);
          break;

        default:
          console.error("Nenhuma posição informada.");
      }

      setRelationship((relationshipCopy) => [
        ...relationshipCopy,
        {
          id: item.id,
          name: item.razao,
          type: StringService.capitalize(item.pivot.tipo),
          position: position,
        },
      ]);
    },
    [setDependentCustomer, setMainCustomer, setRelationship]
  );

  const handleRemoveRelationship = useCallback(
    (relatedCustomer, index) => {
      Swal.fire({
        icon: "question",
        text: "Tem certeza que deseja remover esta relação?",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
      }).then(async (result) => {
        if (result.isConfirmed) {
          switch (relatedCustomer.position) {
            case "Titular":
              setMainCustomer((current) =>
                current.filter(
                  (item) =>
                    item.cliente_titular_id !== relatedCustomer.id ||
                    item.tipo !== relatedCustomer.type
                )
              );
              break;
            case "Dependente":
              setDependentCustomer((current) =>
                current.filter(
                  (item) =>
                    item.cliente_dependente_id !== relatedCustomer.id ||
                    item.tipo !== relatedCustomer.type
                )
              );
              break;

            default:
              console.error("Nenhuma posição informada.");
          }
          setRelationship((current) =>
            current.filter((item, itemIndex) => itemIndex !== index)
          );
          notify("Relação removida com sucesso!", true, "success");
        }
      });
    },
    [setDependentCustomer, setMainCustomer, setRelationship]
  );

  const handleEditItemTable = useCallback(
    (setOpen, setRowEdit, data = {}, index = -1) => {
      setOpen(true);
      setRowEdit({ data, index });
    },
    []
  );

  const handleDeleteClient = (
    id,
    setViewLoading = () => {},
    setReload = () => {},
    canDelete = true
  ) => {
    if (!canDelete) return notify("Cliente não pode ser excluído");
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja excluir o cliente?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setViewLoading(true);
        const callback = await deleteClienteHandler(id, setViewLoading);
        if (!callback?.success)
          return notify("Erro ao excluir cliente, tente novamente.");

        setViewLoading(false);
        setReload((old) => !old);
      }
    });
  };

  const handleChangeUf = (e, setUfParam, setCountyParam) => {
    setUfParam(e);
    setCountyParam(null);
  };

  const clearCutomerContext = useCallback(() => {
    setGeneralCustomerId(null);
    setGeneralTypeSubscription({
      description: "CPF",
      value: "cpf",
    });
    setGeneralCpfCnpj("");
    setGeneralName("");
    setGeneralFantasy("");
    setGeneralCep("");
    setGeneralAddress("");
    setGeneralNewAddress("");
    setGeneralNumber("");
    setGeneralComplement("");
    setGeneralDistrict("");
    setGeneralUf(null);
    setGeneralCounty(null);
    setGeneralNation(
      listNation.find(
        (nation) => nation.codigo === GlobalVariables.countryCodes.brazil
      )
    );
    setGeneralTelephone1("");
    setGeneralTelephone2("");
    setGeneralTelephone3("");
    setGeneralEmail("");
    setGeneralRg("");
    setGeneralIe("");
    setGeneralSimpleNational(false);
    setGeneralFinalCustomer(true);
    setGeneralIm("");
    setGeneralCcm("");
    setGeneralIsuf("");
    setGeneralCheckBudget(true);
    setGeneralCheckNfe(true);
    setGeneralCheckFinancial(true);
    setGeneralIeIndication({
      label: "Não Contribuinte",
      value: 0,
      codigo: "9",
    });
    setGeneralActive(true);
    setGeneralMatriz(null);
    setGeneralSendEmail(true);
    setGeneralDateInitial(
      formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
    );
    setGeneralWebsite("");
    setGeneralSendHub(false);
    setRuralProducer(false);
    setValidCpfCnpj(false);

    //Endereços
    setBillingCep("");
    setBillingAddress("");
    setBillingNewAddress("");
    setBillingNumber("");
    setBillingComplement("");
    setBillingDistrict("");
    setBillingUf(null);
    setBillingCounty(null);
    setDeliveryAddress([]);
    setLoadingTable(false);

    // Estabelecimentos Rurais
    setRuralEstablishment([]);

    //Contatos
    setContacts([]);

    //Autorizados
    setAuthorized([]);

    //Relacionados
    setMainCustomer([]);
    setDependentCustomer([]);
    setRelationship([]);

    //Info. Comerciais
    setSalesman(null);
    setCommercialPartner(null);
    setDefaultPayment(null);
    setTypePayment(null);
    setTableShipping(null);
    setShippingDiscount("0,00");
    setDefaultDiscount("0,00");
    setShippingCompany(null);
    setIrWithheld("0,00");
    setIssWithheld("0,00");
    setCommercialRegionSelect("");
    setInvertDiscount("0,00");

    //Info. Financeiras
    setHasRestriction(false);
    setHasLimit(false);
    setLastSearchSerasa1("");
    setLastSearchSerasa2("");
    setLastSearchSerasa3("");
    setGenerateCommission(true);
    setRiskClass(null);
    setLimitValue("");
    setFinancialObservation("");
    setBillingAlert("");
    setBankInformations([]);
    setMinimumOrder("");

    //Outras Informações
    setOtherShippingCompany(null);
    setOtherOwnHome(null);
    setOtherBirthDate("");
    setOtherFathersName("");
    setOtherRgFather("");
    setOtherCpfFather("");
    setOtherMothersName("");
    setOtherRgMother("");
    setOtherCpfMother("");
    setOtherAdditionalData("");
    setOtherCompanyName("");
    setOtherIssueDate("");
    setOtherRemuneration("0,00");
    setOtherRole("");
    setOtherTelephone("");
    setOtherCounty(null);
    setOtherAddress("");
    setOtherTypeResidence(null);
    setOtherTimeResidence("");
    setOtherFamilyIncome("0,00");
    setOtherPersonalReference("");
    setOtherCommercialReference("");
    setOtherNoteNfe("");
    setOtherPartners([]);

    //Dados do Cônjuge
    setSpousesName("");
    setSpousesBirthDate("");
    setSpousesTelephone("");
    setSpousesRg("");
    setSpousesCpf("");
    setSpousesCompany("");
    setspousesAdmissionDate("");
    setSpousesRole("");
    setSpousesRemuneration("0,00");
    setSpousesCounty(null);
    setSpousesAddress("");

    setExpanded({ general: true });
    setErrors({});
    // eslint-disable-next-line
  }, [
    setDependentCustomer,
    setMainCustomer,
    setRelationship,
    setAuthorized,
    setBankInformations,
    setBillingAddress,
    setBillingNewAddress,
    setBillingNumber,
    setBillingAlert,
    setMinimumOrder,
    setBillingCep,
    setBillingComplement,
    setBillingCounty,
    setBillingDistrict,
    setBillingUf,
    setCommercialPartner,
    setContacts,
    setDefaultDiscount,
    setDefaultPayment,
    setDeliveryAddress,
    setErrors,
    setExpanded,
    setFinancialObservation,
    setGeneralActive,
    setGeneralAddress,
    setGeneralNewAddress,
    setGeneralNumber,
    setGeneralCep,
    setGeneralCheckBudget,
    setGeneralCheckFinancial,
    setGeneralCheckNfe,
    setGeneralComplement,
    setGeneralCounty,
    setGeneralCpfCnpj,
    setGeneralCustomerId,
    setGeneralDateInitial,
    setGeneralDistrict,
    setGeneralEmail,
    setGeneralFantasy,
    setGeneralFinalCustomer,
    setGeneralIe,
    setGeneralIeIndication,
    setGeneralIm,
    setGeneralCcm,
    setGeneralIsuf,
    setGeneralMatriz,
    setGeneralName,
    setGeneralNation,
    setGeneralRg,
    setGeneralSendEmail,
    setGeneralSimpleNational,
    setGeneralTelephone1,
    setGeneralTelephone2,
    setGeneralTelephone3,
    setGeneralTypeSubscription,
    setGeneralUf,
    setGeneralWebsite,
    setGenerateCommission,
    setHasLimit,
    setHasRestriction,
    setIrWithheld,
    setIssWithheld,
    setLastSearchSerasa1,
    setLastSearchSerasa2,
    setLastSearchSerasa3,
    setLimitValue,
    setLoadingTable,
    setOtherAdditionalData,
    setOtherAddress,
    setOtherBirthDate,
    setOtherCommercialReference,
    setOtherCompanyName,
    setOtherCounty,
    setOtherCpfFather,
    setOtherCpfMother,
    setOtherFamilyIncome,
    setOtherFathersName,
    setOtherIssueDate,
    setOtherMothersName,
    setOtherNoteNfe,
    setOtherOwnHome,
    setOtherPersonalReference,
    setOtherRemuneration,
    setOtherRgFather,
    setOtherRgMother,
    setOtherRole,
    setOtherShippingCompany,
    setOtherTelephone,
    setOtherTimeResidence,
    setOtherTypeResidence,
    setOtherPartners,
    setRiskClass,
    setSalesman,
    setShippingCompany,
    setShippingDiscount,
    setSpousesAddress,
    setSpousesBirthDate,
    setSpousesCompany,
    setSpousesCounty,
    setSpousesCpf,
    setSpousesName,
    setSpousesRemuneration,
    setSpousesRg,
    setSpousesRole,
    setSpousesTelephone,
    setTableShipping,
    setTypePayment,
    setspousesAdmissionDate,
    setCommercialRegionSelect,
    setGeneralSendHub,
    setInvertDiscount,
    setRuralProducer,
    setRuralEstablishment,
    setValidCpfCnpj,
  ]);

  return {
    handleSubmit,
    handleCancelSubmit,
    handleChangeOpenAcordion,
    handleDeleteClient,
    handleRemoveItemTable,
    handleAddRelationship,
    handleRemoveRelationship,
    handleEditItemTable,
    handleChangeCep,
    handleChangeCpfCnpj,
    clearCutomerContext,
    handleChangeUf,
    handleBackSubmit,
    deleteClienteHandler,
    clearAccordionCpf,
    clearAccordionCnpj,
    handleSearchSelectShippingCompany,
    handleDialogShippingCompany,
    handleFindShippingCompany,
  };
}
